// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide[data-v-276e6a92]{height:43.5rem}@media only screen and (min-width: 767px){.slide[data-v-276e6a92]{height:31rem}}.slide h2[data-v-276e6a92]{font-size:2.2rem;margin-bottom:.46em}.slide p[data-v-276e6a92]{font-size:1.16rem;margin-bottom:1.1em}a.slide-button[data-v-276e6a92]{padding:.44em .88em;margin-top:.5em;letter-spacing:.03rem;font-size:1.08rem}.image-width[data-v-276e6a92]{max-width:480px}.titles-width[data-v-276e6a92]{max-width:640px}", ""]);
// Exports
module.exports = exports;
